var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb1Home(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.025,
    height: 15.476,
    viewBox: "0 0 14.025 15.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85471",
    "data-name": "Group 85471",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241693",
    "data-name": "Path 241693",
    d: "M10.513,2a.483.483,0,0,1,.3.1L17.339,7.18a.484.484,0,0,1,.187.382v7.98a1.937,1.937,0,0,1-1.935,1.935H5.435A1.937,1.937,0,0,1,3.5,15.542V7.562a.484.484,0,0,1,.187-.382L10.216,2.1A.483.483,0,0,1,10.513,2Zm6.045,5.8L10.513,3.1,4.467,7.8v7.743a.968.968,0,0,0,.967.967H15.591a.968.968,0,0,0,.967-.967Z",
    transform: "translate(-3.5 -2)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241694",
    "data-name": "Path 241694",
    d: "M17.336,25.222a.484.484,0,0,1-.484-.484V17.967H13.467v6.771a.484.484,0,1,1-.967,0V17.484A.484.484,0,0,1,12.984,17h4.353a.484.484,0,0,1,.484.484v7.254A.484.484,0,0,1,17.336,25.222Z",
    transform: "translate(-8.148 -9.747)",
    fill: "#fd930d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb1Home);
export default __webpack_public_path__ + "static/media/Web1_Home.376de897e8fa113762b0a9d84a062eab.svg";
export { ForwardRef as ReactComponent };